export default __webpack_public_path__ + "6761a35ebf37120c808942328d2d55ed.svg";